//Website brede search
define('utils/search',['jquery', 'utils/loader', 'jqueryui/widgets/autocomplete'], function ($, Loader) {
	var current = null;
	var next = null;
	
	var currentContent = null;

	var loader = new Loader();
	
	var config = {
		source: function(request, response) {
			if (request.term.length>2) {
				var func = function() {
					var url = $.url('/search/search');
					
					$('#container').prepend(loader.get());
					
					$.get(url, {q: request.term}, function (data) {
						current = null;
						loader.remove();
						if (currentContent == null)
							currentContent = $('#container').clone();
							
						$('#contents nav').hide();
						response(data.suggest);
						if(data.success != true) {
							$('#container').html('<h1>Er is iets fout gegaan.</h1><p>Zoeken is op dit moment niet beschikbaar. Probeer het later nog eens.</p>');
						}
						$('#container').html(data.html);
					}).always(function() {
						current = next;
						next = null;
						if (current != null)
							current();
					});
				};
				
				if (current==null) {
					current = func;
					current();
				} else
					next = func;
				
			}	
		}
	};
	
	var loaded = false;
	$('#searchbar').on('keyup input paste', function() {
		if (!loaded) {
			$('#searchbar').autocomplete(config);
			loaded = true;
		}
		
		var query = $(this).val();
		if (query.length<=2 && currentContent != null) {
			$('#container').replaceWith(currentContent);
			currentContent = null;
			$('#contents nav').show();
		}
	});
	
	var userAgent = navigator.userAgent;
	if (userAgent.indexOf("Linux; U; Android") > -1 || (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1 )) {
		//Gebruik display:none om render bug in Android < 4.4 op te lossen
		$('#searchbar').attr('style', 'display: none;');
		//Bepaal zelf wanneer tekstveld focus heeft voor Safari en Android < 4.4 
		var clicked = false;
		$('html').click(function() {
			if (!clicked) {
				$('#searchbar').removeClass('focus');
				$('#searchbar').attr('style', 'display: none;');
			} else
				clicked = false;
		});
		$('label[for=searchbar], #searchbar').click(function(e) {
			$('#searchbar').addClass('focus');
			$('#searchbar').focus();
			$('#searchbar').attr('style', 'display: initial;');
			e.stopPropagation();
			clicked = true;
		});
	}
});
